import { useSearchParams } from 'react-router-dom';

import { EFilters } from 'features/Filters';
import { EPaginationParams } from 'features/Pagination';
import { useCommonSlice, useSearchParamsWithHash } from 'shared/hooks';
import { EDefaultOptions } from 'shared/typings';

export const useFilters = (withHash?: boolean) => {
	const [searchParams, setSearchParams] = (withHash ? useSearchParamsWithHash : useSearchParams)();
	const { clearInfinityScroll } = useCommonSlice();

	const setFilter = (field: EFilters, value: string | string[] | boolean | null, searchParams: URLSearchParams) => {
		searchParams.delete(field);
		searchParams.delete(EPaginationParams.OFFSET);

		if (Array.isArray(value)) {
			value
				.filter((item) => item !== EDefaultOptions.ALL)
				.forEach((item) => {
					item && searchParams.append(field, item ? item.toString() : '');
				});
		} else if (value && value !== EDefaultOptions.ALL) {
			searchParams.set(field, value.toString());
		}

		return searchParams;
	};

	return {
		clearFilters: () => {
			const newSearchParams = new URLSearchParams(searchParams);
			for (const key in EFilters) {
				newSearchParams.delete(EFilters[key as keyof typeof EFilters]);
			}

			newSearchParams.delete(EPaginationParams.OFFSET);
			clearInfinityScroll();

			setSearchParams(newSearchParams);
		},
		getFilterValue: (name: EFilters) => {
			return searchParams.get(name) || null;
		},
		getALLFilterValues: (name: EFilters) => {
			return searchParams.getAll(name) || null;
		},
		getFiltersCount: (filters?: EFilters[]) => {
			return Object.values(EFilters).reduce((acc, key) => {
				const param = searchParams.getAll(key);

				if (!param.length || param[0] === EDefaultOptions.ALL || (filters && !filters.includes(key))) {
					return acc;
				}

				return acc + 1;
			}, 0);
		},
		onFilterChange: (field: EFilters, value: string | string[] | boolean | null) => {
			let newSearchParams = new URLSearchParams(searchParams);

			newSearchParams = setFilter(field, value, newSearchParams);

			setSearchParams(newSearchParams, { preventScrollReset: true });
		},
		onMultiFiltersChange: (fields: EFilters[], value: (string | string[] | boolean | null)[]) => {
			let newSearchParams = new URLSearchParams(searchParams);

			fields.forEach((field, index) => {
				newSearchParams = setFilter(field, value[index], newSearchParams);
			});

			setSearchParams(newSearchParams, { preventScrollReset: true });
		},
	};
};
